function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  width: 24,
  height: 24,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h24v24H0z"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#292A2B",
  d: "M6 19v.525q0 .625-.425 1.05T4.5 21q-.625 0-1.062-.437A1.45 1.45 0 0 1 3 19.5V12l2.1-6q.15-.45.538-.725Q6.025 5 6.5 5h11q.475 0 .863.275.387.275.537.725l2.1 6v7.525q0 .625-.425 1.05T19.5 21q-.625 0-1.062-.437A1.45 1.45 0 0 1 18 19.5V19zm-.2-9h12.4l-1.05-3H6.85zm1.7 6q.624 0 1.063-.437Q9 15.125 9 14.5t-.437-1.062A1.45 1.45 0 0 0 7.5 13q-.625 0-1.062.438A1.45 1.45 0 0 0 6 14.5q0 .624.438 1.063Q6.874 16 7.5 16m9 0q.625 0 1.063-.437Q18 15.125 18 14.5t-.437-1.062A1.45 1.45 0 0 0 16.5 13q-.625 0-1.062.438A1.45 1.45 0 0 0 15 14.5q0 .624.438 1.063.437.437 1.062.437"
})));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-car-option.svg";
export { SvgComponent as ReactComponent };